import { HttpErrorResponse } from "@angular/common/http";
import { BrowserOptions, browserTracingIntegration, replayIntegration } from "@sentry/angular";
import { environment } from "./environments/environment";

export const SentryConfig: BrowserOptions = {
  environment: environment.production ? 'production' : 'development',
  release: environment.version,
  dsn: environment.sentryDsn,
  ignoreErrors: [
    'Failed to execute \'transaction\' on \'IDBDatabase\'',
    'The database connection is closing',
    // Sentry Replay's internal IDB worker fails to structured-clone Angular 19 Signal
    // (Proxy) objects captured in DOM snapshots. The error originates inside the SDK
    // itself and is re-reported through the global error handler — suppress to break
    // the circular self-report loop. Root cause: BOOKING-PAGE-16D / BOOKING-PAGE-189.
    'Failed to execute \'put\' on \'IDBObjectStore\'',
    'The object can not be cloned.',
  ],
  beforeSend(event, hint) {
    // status:0 never reaches the browser (client abort/offline/CORS); real faults are 4xx/5xx which we keep. Drop regardless of visibility.
    const original = hint?.originalException;
    const message = event.exception?.values?.[0]?.value ?? '';
    if (
      (original instanceof HttpErrorResponse && original.status === 0) ||
      /Http failure response for .+: 0 Unknown Error/.test(message)
    ) {
      return null;
    }
    return event;
  },
  integrations: [
    browserTracingIntegration(),
    replayIntegration({
      // Limit mutation capture to reduce the surface area of DOM state that
      // Sentry Replay serializes via structured clone; large mutation batches
      // are the primary trigger for the DataCloneError with Angular Signals.
      mutationLimit: 500,
      mutationBreadcrumbLimit: 100,
    }),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0.8,
};
